import ReactTooltip from "react-tooltip";
import React from 'react'

function getToolTipFormatedStrForIPSDT(title, str, project)
{
    if(str === null)
        return (<div></div>);
    let list = str.split(',');
    if(list.length < 4)
    {
        return (
            <span>{list.map(desc => (
                desc
            )).join(',')}</span>
        )
    }
    else if(list.length > 3) {
        return (
            <>
                <div data-tip data-for={'toolTip-'+title+'-'+project.bpid+'-'+project.workOrder} style={{alignItems: 'left'}}>
                    {list.slice(0,3).map(desc => (
                    desc)).join(',')}{' ...'}</div>
                <ReactTooltip id={'toolTip-'+title+'-'+project.bpid+'-'+project.workOrder}
                              place="bottom" effect="solid" textColor='black' backgroundColor='white' border={true} borderColor="black" type="info">
                    {list.map(item => (
                        item
                    )).join(',')}
                </ReactTooltip>
            </>
        )
    }
}

export {getToolTipFormatedStrForIPSDT}